
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  
  Flits(document).on('Flits:contactUS:Loaded', function(event){  
    setInterval(function(){
      var data = event.detail;
      Flits.shopCountryName = 'Germany';
    },1000); 
  });
  
 if(location.pathname.indexOf("/account") != -1){
  Flits(document).on('click', '.flits-custom-tab', function(e){
    var elem = Flits(this).attr('href');
    var el = elem.replace('#', '');
    Flits('.flits-account-page-container').addClass('flits-active');
    
    Flits('.flits-nav-tabs li a').removeClass('flits-active');
    Flits('.flits-custom-tab-add').removeClass('flits-active');
    Flits('a[href="'+elem+'"]').addClass('flits-active');

    Flits('.flits-tab-box').removeClass('flits-active');
    Flits('#flits_tab_'+el).addClass('flits-active');
  });
}

   // WISHLIST
 if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
   Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
 }
 Flits(document).on('Flits:wishlistButton:Loaded', function(event){
   if (Flits.request.page_type == 'index' || Flits.request.page_type == 'product') {
     let collectionBtn = Flits('.flits-wishlist-colection');
     parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
       Flits(collectionBtn).show(),
       Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
   }
 });
  

  
  var ajaxWishlistViewFunction = function(xhrOrFetch) {
    var url = this._url;

    // You can add your choice of URL Instead '?view=ajax'
    (-1 !== url.indexOf("?sort_by=") || ("?page=")) && Flits.dispatchEvent("Flits:AjaxWishlist", { 
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunction);
  Flits.addFetchEvents(ajaxWishlistViewFunction);
  
  function flitsShowWishlistButton(){
    let collectionBtn = Flits('#CollectionSection .flits-wishlist-colection');
    parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
      Flits(collectionBtn).show(),
      Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent'); 
  }


  Flits(document).on("Flits:AjaxWishlist", function(){
    setTimeout(function(){  
      var grid = Flits("#collection").find(".flits-wishlist-colection .flits-wls-button");
      Flits(grid).each(function(index,single_grid_item){
        var handle = Flits(single_grid_item).attr('data-flits-product-handle');
        Flits(single_grid_item).parent().css('display','flex');
        Flits(single_grid_item).find('.flits-wls-icon-with-text-text').css('display','flex');
        if(Flits.isProductAddedInWishlist(handle)){ 
          Flits(single_grid_item).removeClass("flits-wls-inactive")
          Flits(single_grid_item).addClass("flits-wls-active")
        }
      });
      flitsShowWishlistButton();
    }, 1000);
  });
  
}(Flits));
